import styles from './input.module.css';
import { useState } from 'react';
import { useRef } from 'react';
import '../../global.css';

const Input = ({onClickHandler}) => {

    const [inputType, setInputType] = useState('text');

    function changeInputType (type) {
        setInputType(type);
    }

    function input() {
        var text = '';
        if(inputType === 'text') {
            text = document.getElementById("textInputField").value;
        }
        else {
            text = document.getElementById("linkInputField").value;
        }
        onClickHandler(text, inputType);
    }

    function linkInputHandler() {
        var text = document.getElementById("linkInputField").value;
        
    }

    return(
        <div className = {styles.body}>
            <div className = {styles.inputBox}>
                <div className = {styles.inputOptionsList}>
                    <div className = {styles.inputOption} onClick = {() => changeInputType('text')}>Text</div>
                    <div className = {styles.inputOption} onClick = {() => changeInputType('link')}>YouTube Link</div>
                </div>
                {
                    (inputType === 'text')
                    ?   <div>
                            <input placeholder = 'Enter text' id = "textInputField"/>
                        </div>

                    :   <div>
                            <input placeholder = 'Enter link' id = "linkInputField"/>
                        </div>
                }
                <button onClick={input}>Submit</button>
            </div>
        </div>
    )
}

export default Input;